import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "../../utils/axios";
import { Form, Alert, Row, Col } from "react-bootstrap";

const AddChannelForm = ({
  isSubmitting,
  formRef,
  toggle,
  alertChannel,
  ...props
}: any) => {
  const types = [
    // {
    //   value: "SMS",
    //   label: "SMS",
    // },
    {
      value: "Email",
      label: "Email",
    },
    // {
    //   value: "Slack",
    //   label: "Slack",
    // },
  ];

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        channelName: alertChannel.name,
        channelType: alertChannel.type || "Email",
        channelValue: alertChannel.value,
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        channelName: Yup.string().max(255).required("Prosim vnesi opis"),
        channelType: Yup.string().max(255).required("Prosim izberi tip"),
        channelValue: Yup.string().max(255).required("Prosim vnesi vrednost"),
      })}
      onSubmit={async (
        values: any,
        { setErrors, setStatus, setSubmitting }
      ) => {
        try {
          const submitValues = Object.keys(values).reduce(
            (allValues: any, key: any) => {
              if (values[key] === 0) {
                allValues[key.replace("channel", "").toLowerCase()] = null;
              } else {
                allValues[key.replace("channel", "").toLowerCase()] =
                  values[key];
              }
              return allValues;
            },
            {}
          );

          let response;
          if (alertChannel.id) {
            response = await axios
              .put("/alerts/channels/" + alertChannel.id, submitValues)
              .catch((e) => {
                throw e;
              });
          } else {
            response = await axios
              .post("/alerts/channels", submitValues)
              .catch((e) => {
                throw e;
              });
          }

          if (response) {
            toggle(true);
          }
        } catch (error: any) {
          console.error(error);
          const message = error.message || "Prišlo je do napake";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit} key="channelForm">
          {errors.submit && (
            <Alert variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="channelType">Način</Form.Label>
                <Form.Select
                  name="channelType"
                  id="channelType"
                  as="input"
                  size="lg"
                  value={values.channelType}
                  placeholder="Vpiši način obveščanja"
                  isInvalid={Boolean(touched.channelType && errors.channelType)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Način"
                >
                  {types.map((value: any, index) => (
                    <option value={value.value} key={"type_" + index}>
                      {value.label}
                    </option>
                  ))}
                </Form.Select>
                {!!touched.channelType && (
                  <Form.Control.Feedback type="invalid">
                    {errors.channelType}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              {values.channelType === "SMS" ? (
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="value">Telefonska številka</Form.Label>
                  <Form.Control
                    type="tel"
                    name="channelValue"
                    id="value"
                    pattern="[0-9]{3} [0-9]{3} [0-9]{3}"
                    value={values.channelValue}
                    placeholder="031 123 456"
                    isInvalid={Boolean(
                      touched.channelValue && errors.channelValue
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {!!touched.channelValue && (
                    <Form.Control.Feedback type="invalid">
                      {errors.channelValue}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              ) : values.channelType === "Email" ? (
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="value">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="channelValue"
                    id="value"
                    value={values.channelValue}
                    placeholder="info@avto-oglasi.si"
                    isInvalid={Boolean(
                      touched.channelValue && errors.channelValue
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {!!touched.channelValue && (
                    <Form.Control.Feedback type="invalid">
                      {errors.channelValue}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              ) : values.channelType === "Slack" ? (
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="value">Slack Webhook URL</Form.Label>
                  <Form.Control
                    type="text"
                    name="channelValue"
                    id="value"
                    value={values.channelValue}
                    placeholder="https://..."
                    isInvalid={Boolean(
                      touched.channelValue && errors.channelValue
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {!!touched.channelValue && (
                    <Form.Control.Feedback type="invalid">
                      {errors.channelValue}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="channelName">Opis</Form.Label>
                <Form.Control
                  type="text"
                  name="channelName"
                  id="channelName"
                  placeholder="Opis"
                  value={values.channelName}
                  isInvalid={Boolean(touched.channelName && errors.channelName)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.channelName && (
                  <Form.Control.Feedback type="invalid">
                    {errors.channelName}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default AddChannelForm;
